export const localeRoot = "settings.paywalls.modal.tabs.checkout";

export const PROPERTIES = {
  DEFAULT: "default",
  TESTIMONIALS: "testimonials",
  BADGES: "badges",
  BENEFITS: "benefits",
  COUNTDOWN: "countdown",
  PRICE_CALLOUTS: "price_callouts",
};

export const DISPLAY_STYLE_OPTIONS = {
  STARS: "stars",
  QUOTATION_MARK: "quotation_mark",
};

export const DISPLAY_STYLE_DEFAULT_COLORS = {
  STARS: "#FDB022",
  QUOTATION_MARK: "#000000",
};
